import React, { useState, type ReactNode } from 'react';

import { Global, css, ThemeProvider } from '@emotion/react';
import { ERebrandingColors } from 'helpers/constants';

import createTokens from '@eduzz/houston-tokens';

const registryBlockOverrides = css`
  .registry-block-alert-bridge {
    --ant-color-primary: ${ERebrandingColors.MAIN};
  }

  .registry-block-alert-bridge #registry-block-alert-ok-button.ant-btn-primary:not(:disabled),
  .registry-block-alert-bridge #registry-block-alert-ok-button.ant-btn-color-primary:not(:disabled) {
    background: ${ERebrandingColors.MAIN} !important;
    border-color: ${ERebrandingColors.MAIN} !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    min-height: 40px !important;
    height: auto !important;
    padding: 7.75px 16px !important;
    line-height: normal !important;
  }
`;

type Props = { children: ReactNode };

/**
 * Overrides CSS para Ant Design do bundle federado.
 * O vertical já carrega sua própria instância de antd via Module Federation.
 */
const RegistryBlockAlertBridge = ({ children }: Props) => {
  const [theme] = useState(() => {
    const theme = createTokens('eduzz');
    const originalSpacing = { ...theme.spacing };
    theme.spacing = theme.spacing.fn as any;
    Object.assign(theme.spacing, originalSpacing);
    return theme;
  });

  return (
    <ThemeProvider theme={theme as any}>
      <Global styles={registryBlockOverrides} />
      <div className='registry-block-alert-bridge'>{children}</div>
    </ThemeProvider>
  );
};

export default RegistryBlockAlertBridge;
